<ym-modal (onClose)="toggleModal()">
    <ng-container header>
        <div class="ym-display-flex ym-gap-3 ym-justify-content-center ym-align-items-center">
            <span class="icon ym-svg-md">
                <ym-icon [iconName]="iconNames.FILTER"></ym-icon>
            </span>
            Filter
        </div>
    </ng-container>
    <ng-container body>
        <div class="main-content ym-display-flex ym-flex-direction-column ym-h-full ym-gap-5 ym-mb-5">
            <ng-content></ng-content>
            <app-filter [filter]="filter" [fieldDocuments]="fieldDocuments" [fieldGroups]="fieldGroups"
                [allUsers]="allUsers" (onFilterChange)="updateFilter($event)"></app-filter>
        </div>
    </ng-container>

    <ng-container actions>
        <ym-button [type]="buttonTypes.PRIMARY" [loading]="isLoading" (onClick)="saveFilter()">
            Apply
        </ym-button>
    </ng-container>
</ym-modal>